class MermaidGenerator {
    constructor() {
        this.shape_mapping = {
            "if": ["{", "}"],
            "box": ["[", "]"],
            "start": ["([", "])"],
            "end": ["([", "])"],
            "process": ["[[", "]]"],
            "input": ["[/", "/]"],
            "output": ["[\\", "\\]"],
        };

        this.class_mapping = {
            "if": "decision",
            'start': 'start',
            'end': 'end',
            'box': 'operation',
            'process': 'subroutine',
            'input': 'operation',
            'output': 'operation',
        };

        this.class_def = {
            'start': {
                'color': '#fff',
                'stroke': '#b39b16',
                'fill': '#F9D423'
            },

            'end': {
                'color': '#fff',
                'stroke': '#b99d1a',
                'fill': '#F9D423'
            },

            'operation': {
                'color': '#fff',
                'stroke': '#097294',
                'fill': '#0DC0F7'
            },

            'decision': {
                'color': '#fff',
                'stroke': '#097294',
                'fill': '#0DC0F7'
            },

            'subroutine': {
                'color': '#fff',
                'stroke': '#5a7a00',
                'fill': '#8FBE00'
            }
        };

        this.arr = [];
        this.styles = {};
    }

    generate_shape(shape) {
        const mapping = this.shape_mapping;
        const arr = this.arr;

        let id = shape.get_id();
        let op = "    " + id;
        let text = shape.text;
        let typ = shape.shape;

        if (!mapping[typ]) {
            throw new Error("Invalid Syntax");
        }

        let style = shape.style || typ;
        this.styles[id] = this.class_mapping[style] || this.class_mapping[typ];

        typ = mapping[typ];
        text = typ[0] + text + typ[1];

        op = op + text;
        arr.push(op);
    }

    generate_connection(shape) {
        let next_item;

        const arr = this.arr;
        const branches = shape.branches;
        const has_branches = Object.keys(branches).length > 0;
        const tmpl = "    {0}-->{2}";
        const tmpl1 = "    {a}-->|{branch}|{b}";

        if (!has_branches) {
            next_item = shape.get_next_item();
            if (next_item) {
                let a = shape.get_id();
                let b = next_item.get_id();


                let op = tmpl;
                op = op.replace("{0}", a);
                op = op.replace("{2}", b);

                arr.push(op);
            }
        } else {
            let branch;
            for (branch in branches) {
                next_item = branches[branch][0];

                let a = shape.get_id();
                let b = next_item.get_id();

                let op = tmpl1;
                op = op.replace("{a}", a);
                op = op.replace("{b}", b);
                op = op.replace("{branch}", branch);

                arr.push(op);

            }
        }
    }

    get_class_def() {
        for (let name in this.class_def) {
            let class_def = this.class_def[name];
            let code = "    classDef " + name.toUpperCase();

            for (let prop in class_def) {
                code += " " + prop + ":" + class_def[prop] + ",";
            }
            code = code.substr(0, code.length - 1);
            code = code + ";";
            this.arr.push(code);
        }
    }

    add_classes() {
        let styles = this.styles;
        let arr = this.arr;

        for (let id in styles) {
            let style = styles[id];
            if (style !== "") {
                let code = "    class " + id;
                code += " " + style.toUpperCase();
                arr.push(code);
            }
        }
    }

    get_code(diagram) {
        this.styles = {};
        this.arr = ["graph TD"];

        diagram.print_ids(this);
        this.arr.push('');
        diagram.print_connections(this);
        this.arr.push('');
        this.get_class_def();
        this.arr.push('');
        this.add_classes();

        return this.arr.join("\n");
    }
}

export default MermaidGenerator;
